import type { TypeTableColumn } from '@thefarmersfront/kitchen';

import { NumberInputCell } from '~/components/common';

import { formatNumber } from '~/utils/common';

import type { TypeInputStatus } from '~/types/common.types';
import type { TypeReceivingLabelItem } from '~/types/receive.types';

/** 라벨 수 입력 상태를 행에 함께 싣는다. 컬럼이 입력 상태에 따라 바뀌면 입력 셀이 다시 마운트돼 포커스를 잃는다. */
export type TypeReceivingLabelRow = TypeReceivingLabelItem & { labelStatus?: TypeInputStatus };

const numberColumn = (
  accessorKey: 'box' | 'unitPerBox' | 'unit' | 'totalUnit',
  header: string,
  size: number
): TypeTableColumn<TypeReceivingLabelRow> => ({
  accessorKey,
  header,
  size,
  cell: ({ getValue }) => {
    const value = getValue<number | null | undefined>();
    return value !== null && value !== undefined ? formatNumber(value) : '-';
  },
  meta: { cellStyle: { textAlign: 'right' } },
});

/**
 * [입고관리 > 입고요청관리] 입하 라벨 출력 모달 테이블
 */
const getReceiveLabelPrintModalColumnDefs = ({
  onLabelCountChange,
  onLabelCountFocus,
}: {
  onLabelCountChange: (receivingRequestItemId: number, value: string) => void;
  onLabelCountFocus: (receivingRequestItemId: number) => void;
}) => {
  const columnDefs: TypeTableColumn<TypeReceivingLabelRow>[] = [
    {
      id: 'selection',
      header: '',
      cell: () => null,
      size: 44,
      meta: { selection: true },
    },
    {
      accessorKey: 'goodsCode',
      header: '상품코드',
      size: 140,
    },
    {
      accessorKey: 'goodsName',
      header: '상품명',
      size: 180,
    },
    {
      id: 'usePallet',
      accessorFn: (data) => (data.usePallet ? '사용함' : '사용안함'),
      header: '파렛트 사용여부',
      size: 114,
    },
    numberColumn('box', '수량(BOX)', 88),
    numberColumn('unitPerBox', '입수(BOX당)', 100),
    numberColumn('unit', '수량(EA)', 78),
    numberColumn('totalUnit', '총 수량(EA)', 94),
    {
      accessorKey: 'label',
      header: '라벨 수',
      size: 96,
      minSize: 96,
      cell: ({ row }) => {
        const data = row.original;
        return (
          <NumberInputCell
            value={data.label?.toString() || ''}
            status={data.labelStatus}
            onChange={(value) => onLabelCountChange(data.receivingRequestItemId, value)}
            onFocus={() => onLabelCountFocus(data.receivingRequestItemId)}
          />
        );
      },
    },
  ];

  return { columnDefs };
};

export default getReceiveLabelPrintModalColumnDefs;
